import { dew as _RecordsResponseDew } from "./RecordsResponse";
import { dew as _RecordsResponseDataDew } from "./RecordsResponseData";
import { dew as _GetRecordsResponseDew } from "./GetRecordsResponse";
import { dew as _GetRecordsResponseDataDew } from "./GetRecordsResponseData";
import { dew as _RecordCountsDew } from "./RecordCounts";
import { dew as _RecordsWithLinksDew } from "./RecordsWithLinks";
import { dew as _RecordWithLinksDew } from "./RecordWithLinks";
import { dew as _RecordDataWithLinksDew } from "./RecordDataWithLinks";
import { dew as _CellValueWithLinksDew } from "./CellValueWithLinks";
import { dew as _RecordBaseDew } from "./RecordBase";
import { dew as _RecordsDew } from "./Records";
import { dew as _Record_Dew } from "./Record_";
import { dew as _RecordDataDew } from "./RecordData";
import { dew as _CellValueDew } from "./CellValue";
import { dew as _CellValueUnionDew } from "./CellValueUnion";
import { dew as _DiffRecordsResponseDew } from "./DiffRecordsResponse";
import { dew as _DiffRecordsDew } from "./DiffRecords";
import { dew as _DiffRecordDew } from "./DiffRecord";
import { dew as _DiffDataDew } from "./DiffData";
import { dew as _DiffValueDew } from "./DiffValue";
import { dew as _ValidationMessageDew } from "./ValidationMessage";
import { dew as _ValidationTypeDew } from "./ValidationType";
import { dew as _ValidationSourceDew } from "./ValidationSource";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  var __createBinding = exports && exports.__createBinding || (Object.create ? function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = {
        enumerable: true,
        get: function () {
          return m[k];
        }
      };
    }
    Object.defineProperty(o, k2, desc);
  } : function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
  });
  var __exportStar = exports && exports.__exportStar || function (m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  __exportStar(_RecordsResponseDew(), exports);
  __exportStar(_RecordsResponseDataDew(), exports);
  __exportStar(_GetRecordsResponseDew(), exports);
  __exportStar(_GetRecordsResponseDataDew(), exports);
  __exportStar(_RecordCountsDew(), exports);
  __exportStar(_RecordsWithLinksDew(), exports);
  __exportStar(_RecordWithLinksDew(), exports);
  __exportStar(_RecordDataWithLinksDew(), exports);
  __exportStar(_CellValueWithLinksDew(), exports);
  __exportStar(_RecordBaseDew(), exports);
  __exportStar(_RecordsDew(), exports);
  __exportStar(_Record_Dew(), exports);
  __exportStar(_RecordDataDew(), exports);
  __exportStar(_CellValueDew(), exports);
  __exportStar(_CellValueUnionDew(), exports);
  __exportStar(_DiffRecordsResponseDew(), exports);
  __exportStar(_DiffRecordsDew(), exports);
  __exportStar(_DiffRecordDew(), exports);
  __exportStar(_DiffDataDew(), exports);
  __exportStar(_DiffValueDew(), exports);
  __exportStar(_ValidationMessageDew(), exports);
  __exportStar(_ValidationTypeDew(), exports);
  __exportStar(_ValidationSourceDew(), exports);
  return exports;
}